
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/customization/tailwind",
      function () {
        return require("private-next-pages/x/react-chat/customization/tailwind.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/customization/tailwind"])
      });
    }
  